import React, { useState, useEffect, useRef }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../../tooling/formatTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';

import MetricDimensionParamsEditor from './objectInputs/metricDimensionParamsEditor';
import CalculationMetricParamEditor from './objectInputs/calculationMetricParamEditor';
import InReduceXMetricOrderEditor from './objectInputs/inReduceXMetricOrderEditor';
import TextBox from '../../common/inputs/textBox';
import Select from '../../common/inputs/select';

const FormulaMetricEditor = props => {
  const objectFormulaInput = useRef(null);  
  const {
    polynomialsList,
    dimensionsList,
    dimensionInstancesOptions,
    dimensionInstancesFetch,
    dimensionInstancesLoading,
    entity,
    entityOptions,    
    formulaType,
    onChange,
    handleGoToEditFormula,
    handleDeleteEntity,    
    escBehaviourHandler,
    disabled,    
  } = props;
  
  const onObjectFormulaHelperClick = (event) => {
    let helperText = event.currentTarget.dataset.helpertext;
    let newValue = entity.object_formula ? entity.object_formula : "";
    if(objectFormulaInput && !isNaN(objectFormulaInput.current.selectionStart)) {
      let position = Math.min(objectFormulaInput.current.selectionStart, Math.max(newValue.length,0));
      newValue = newValue.substring(0,position) + helperText + newValue.substring(position);
    }
    else {
      newValue = newValue + helperText;
    }
    onChange({
      currentTarget: {
        dataset: {
          path: "object_formula"
        },
        value: newValue
      }
    })
  };
  let idsArray = [];
  let order_by_descriptor = entity.order_by_descriptor ? entity.order_by_descriptor : [];
  let dimensionParams = entity.childs.map(item => {
    if(!item.is_value_param){
      idsArray.push(+item.id); 
    }
    return {
      dimension_id: item.id,
      dimension_name: item.name,
      negation: item.negation,
      type: item.type,        
      is_value_param: item.is_value_param,
      validation_dimension_id: item.validation_dimension_id,
      value: (item.type==Constants.selectKeys.formulaEditor.metricParamTypes.FREE || item.type==Constants.selectKeys.formulaEditor.metricParamTypes.EMPTY || item.type==Constants.selectKeys.formulaEditor.metricParamTypes.ALL || item.type==Constants.selectKeys.formulaEditor.systemDimensionParamTypes.ALL_ACTIVE || item.type=="") ? 
        "" : (item.content.length>0 ? 
          (item.type==Constants.selectKeys.formulaEditor.metricParamTypes.CONTEXT_DIMENSION ? item.content[0].name : (
            item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].period_limit : item.content[0])
          ) : ""),
      period_dimension_ignore_empty: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].ignore_empty : false,
      period_dimension_ignore_actual: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].ignore_actual : false,
      period_dimension_series: item.type == Constants.selectKeys.formulaEditor.periodParamExtraType.HISTORIC_PERIODS ? item.content[0].series : ""
    }
  });

  if(entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC){
    dimensionParams = dimensionParams.filter(item => !item.is_value_param)
  }

  let metricTypeOptions = entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC ? 
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.loadMetricParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues") :
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.metricParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues");
  let metricSystemDimensionTypeOptions = entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC ? 
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.loadMetricParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues") :
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.systemDimensionParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues");
  let metricOrderTypeOptions = entity.virtual_calculation ? 
    InterfaceTooling.getSelectArray("selectKeys.formulaEditor.reduceXMetricOrderTypes.columnTypes","polynomialAdmin.formulaEditor.entityEditor.reduceXVirtualCalcularionOrderValues") 
    : InterfaceTooling.getSelectArray("selectKeys.formulaEditor.reduceXMetricOrderTypes.columnTypes","polynomialAdmin.formulaEditor.entityEditor.reduceXMetricOrderValues");
  let loadMetricObjectGroupOptions = [];
  if(entity.object_definition && entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) {
    loadMetricObjectGroupOptions.push({value: "", label: ""});
    for(let i=1; i<=Constants.interface.loadMetricObjectGroupSelectOptionsNumber; i++) {
      loadMetricObjectGroupOptions.push({
        value: entity.name.toUpperCase() + '_OBJECT_GROUP_' + i,
        label: entity.name + " - " + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.loadMetricObjectGroupOptionBaseLabel"}) + " " + i
      });    
    }
  }
  return (
    <div className="formula_editor_editor_entity_wrapper">
      <div className="formula_editor_editor_entity_label">
        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeName." + entity.type }) + ": " + entity.name}
        {!disabled && (<span className="simulated-a" onClick={handleDeleteEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.deleteEntity"/></span>)}
      </div>
      <div className="formula_editor_editor_entity_inner">
        <div className="formula_editor_editor_entity_inner_left">
          {(!entity.virtual_calculation) && (
            <MetricDimensionParamsEditor
              dimensionList={dimensionsList}
              dimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList, "name", "name")}
              typeOptions={metricTypeOptions}
              periodTypeExtraOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.periodParamExtraType","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues",false)}
              systemDimensionTypeOptions={metricSystemDimensionTypeOptions}
              typeValueOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.metricValueParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesValueSelectValues",false)}
              negationOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.negationOptions","polynomialAdmin.formulaEditor.entityEditor.negationSelectValues")}
              dimensionInstancesOptions={dimensionInstancesOptions}
              dimensionInstancesFetch={dimensionInstancesFetch}
              dimensionInstancesLoading={dimensionInstancesLoading}
              values={dimensionParams}
              onChange={onChange}
              handleGoToEditFormula={handleGoToEditFormula}
              loadMetricModeActive={(entity.metric_type==Constants.metricAdmin.metricType.DYNAMIC) && (entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC)}
              disabled={disabled}
              escBehaviourHandler={escBehaviourHandler}
            />
          )}
          {(entity.virtual_calculation) && (
            <CalculationMetricParamEditor
              dimensionList={dimensionsList}
              dimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(item => !idsArray.includes(+item.id)), "id", "name")}
              fullDimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList, "name", "name")}
              typeOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.calculationMetricParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues")}
              periodTypeExtraOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.periodParamExtraType","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues",false)}
              systemDimensionTypeOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.systemDimensionCalculationParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues")}
              typeValueOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.metricValueParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesValueSelectValues",false)}
              negationOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.negationOptions","polynomialAdmin.formulaEditor.entityEditor.negationSelectValues")}
              dimensionInstancesOptions={dimensionInstancesOptions}
              dimensionInstancesFetch={dimensionInstancesFetch}
              dimensionInstancesLoading={dimensionInstancesLoading}
              values={dimensionParams}
              onChange={onChange}
              handleGoToEditFormula={handleGoToEditFormula}
              disabled={disabled}
              escBehaviourHandler={escBehaviourHandler}
            />
          )}
          {((entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC) && formulaType!=Constants.formulaEditor.formulaTypes.METRIC) && (
            <InReduceXMetricOrderEditor
              typeColumnOptions={metricOrderTypeOptions}
              dimensionColumnOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(item => idsArray.includes(+item.id)), "name", "name")}
              valueColumnOptions={entity.object_definition ? 
                InterfaceTooling.getSelectArrayFromArrayOfObjects(entity.object_definition, "name", "name") : 
                (entity.virtual_calculation ? 
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.onlyValueSelect","polynomialAdmin.formulaEditor.virtualCalculationOrderColumnsLabels.onlyValueOptions",) :
                  InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.onlyValueSelect","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.onlyValueOptions") )}
              data-path="order_by_descriptor"
              titleLabel={intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.order_by_descriptor"})}
              values={order_by_descriptor}
              onChange={onChange}
              escBehaviourHandler={escBehaviourHandler}
            />
          )}
        </div>
        {(entity.object_definition || 
         entityOptions.metricBehaviour != Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC ||
         entity.virtual_calculation) && (
          <div className={"formula_editor_editor_entity_inner_right formula_editor_editor_entity_options" + ((entity.object_definition && (entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC)) ? " formula_editor_editor_entity_reducex_options" : "")}>
            <div className="formula_editor_editor_entity_section_label">
              {(entity.virtual_calculation) && (
                <Select
                  className={(!entity.calculation_metric_polynomial_name) ? "has_error" : ""}
                  data-path="calculation_metric_polynomial_name"
                  value={entity.calculation_metric_polynomial_name ? entity.calculation_metric_polynomial_name : ""}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.calculationMetricPolynomialLabel"/>}
                  options={InterfaceTooling.getSelectArrayFromArrayOfObjects(polynomialsList, "name", "name")}
                />
              )}
              {(entityOptions.metricBehaviour != Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC && entityOptions.metricBehaviour != Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) && (
                <Select
                  data-path="reducer"
                  value={entity.reducer}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.reducerLabel"/>}
                  options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.metricReducerTypes","polynomialAdmin.formulaEditor.entityEditor.metricReducersSelectValues", false)}
                />
              )}
              {(entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC && entityOptions.sumxMetricsNamesOptions && entityOptions.sumxMetricsNamesOptions.length>1) && (
                <Select
                  data-path="load_metric_context"
                  value={"load_metric_context" in entity ? entity.load_metric_context : ""}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.loadMetricContextLabel"/>}
                  options={entityOptions.sumxMetricsNamesOptions}                  
                />
              )}
              {(entity.object_definition && entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) && (
                <Select
                  className={!entity.object_formula ? " has_error" : ""}
                  data-path="object_formula"
                  value={entity.object_formula}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.objectFormulaLoadMetricLabel"/>}
                  options={InterfaceTooling.getSelectArrayFromArrayOfObjects(entity.object_definition, "id", "name").map(item => 
                    ({value: (item.value ? "'" + item.label + "'" : ""), label: item.label}) )}
                />
              )}
              {(entity.object_definition && entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) && (
                <Select
                  data-path="load_metric_object_group"
                  value={"load_metric_object_group" in entity ? entity.load_metric_object_group : ""}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.loadMetricObjectGroupLabel"/>}
                  options={loadMetricObjectGroupOptions}
                />
              )}
              {(entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) && (
                <Select
                  data-path="load_metric_overwrite_unique"
                  value={"load_metric_overwrite_unique" in entity ? entity.load_metric_overwrite_unique : ""}
                  onChange={onChange}
                  disabled={disabled}
                  labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.loadMetricOverwriteUnique"/>}
                  options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.optionsBooleanOnlyYes","polynomialAdmin.formulaEditor.entityEditor.optionsBooleanSelectValues")}
                />
              )}
              {(entity.object_definition && entityOptions.metricBehaviour != Constants.formulaEditor.metricBehaviour.LOADABLE_METRIC) && (
                <React.Fragment>
                  <TextBox 
                    className={"formula_editor_metric_object_def_textbox" + ((!entity.object_formula) ? " has_error" : "")}
                    styleType={Constants.interface.inputs.styleType.OUTLINED}
                    type={Constants.interface.inputs.type.TEXT}
                    data-path="object_formula"
                    value={entity.object_formula}
                    onChange={onChange}
                    ref={objectFormulaInput}
                    labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.objectFormulaLabel"/>}
                    disabled={disabled}
                  />
                  {!disabled && (
                    <div className="formula_editor_metric_object_helper_wrapper">
                      {entity.object_definition.map((object_attribute, index) => {
                        return (
                          <div
                            onClick={onObjectFormulaHelperClick}
                            key={index}
                            data-helpertext={"'" + object_attribute.name + "'"}
                            title={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.objectFormulaHelperAttributesLabel"})}
                            className="formula_editor_metric_object_helper"
                          >
                            {object_attribute.name}
                          </div>);
                      })}
                      <div
                        onClick={onObjectFormulaHelperClick}
                        data-helpertext={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionDays"}) + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionParams"})}
                        title={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.objectFormulaHelperFunctionsLabel"})}
                        className="formula_editor_metric_object_helper"
                      >
                        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionSufix"}) + ": " + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionDays"})}
                      </div>
                      <div
                        onClick={onObjectFormulaHelperClick}
                        data-helpertext={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionHours"}) + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionParams"})}
                        title={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.objectFormulaHelperFunctionsLabel"})}
                        className="formula_editor_metric_object_helper"
                      >
                        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionSufix"}) + ": " + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionHours"})}
                      </div>
                      <div
                        onClick={onObjectFormulaHelperClick}
                        data-helpertext={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionMinutes"}) + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionParams"})}
                        title={intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.objectFormulaHelperFunctionsLabel"})}
                        className="formula_editor_metric_object_helper"
                      >
                        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionSufix"}) + ": " + intl.formatMessage({id:"polynomialAdmin.formulaEditor.entityEditor.functionMinutes"})}
                      </div>
                    </div>
                  )}
                  {(entityOptions.metricBehaviour == Constants.formulaEditor.metricBehaviour.ITERABLE_METRIC) && (
                    <label className="form_info">
                      <FormattedMessage 
                        id={"polynomialAdmin.formulaEditor.entityEditor.objectDefinitionDisclaimerCase"}
                      />
                    </label>
                  )}
                </React.Fragment>                
              )}                   
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormulaMetricEditor;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/formulaMetricEditor.jsx